export default {
  // —— Console/Admin OpenAPI ——
  'pages.openapi.overview.title': 'Open-Platform-Übersicht',
  'pages.openapi.overview.loadFailed': 'Nutzungsübersicht konnte nicht geladen werden (API möglicherweise noch nicht bereit)',
  'pages.openapi.overview.docsTitle': 'Integrationsleitfaden',
  'pages.openapi.overview.docsDesc':
    'Open-Platform-BasePath ist /v1. Antwortumschlag ist {code,message,data,request_id}. Für API Keys Authorization: Bearer sk_live_... / sk_test_... senden. Der Klartextschlüssel wird nur einmal bei Erstellung oder Rotation angezeigt—bitte sicher speichern.',
  'pages.openapi.overview.level': 'Aktuelle Stufe',
  'pages.openapi.overview.qps': 'QPS-Limit',
  'pages.openapi.overview.apps': 'Apps',
  'pages.openapi.overview.appsSuffix': '(max. {maxApps}, Keys pro App {maxKeys})',
  'pages.openapi.status.active': 'Aktiv',
  'pages.openapi.status.disabled': 'Deaktiviert',
  'pages.openapi.apps.title': 'Apps & Schlüssel',
  'pages.openapi.apps.listTitle': 'Meine Apps',
  'pages.openapi.apps.create': 'App erstellen',
  'pages.openapi.apps.createModal': 'App erstellen',
  'pages.openapi.apps.name': 'App-Name',
  'pages.openapi.apps.nameRequired': 'Bitte Namen eingeben',
  'pages.openapi.apps.description': 'Beschreibung',
  'pages.openapi.apps.status': 'Status',
  'pages.openapi.apps.createdAt': 'Erstellt am',
  'pages.openapi.apps.createSuccess': 'App erstellt',
  'pages.openapi.apps.createFailed': 'App-Erstellung fehlgeschlagen',
  'pages.openapi.apps.loadFailed': 'Apps konnten nicht geladen werden',
  'pages.openapi.apps.keysLoadFailed': 'Schlüssel konnten nicht geladen werden',
  'pages.openapi.apps.delete': 'Löschen',
  'pages.openapi.apps.deleteConfirm': 'Diese App löschen?',
  'pages.openapi.apps.deleted': 'Gelöscht',
  'pages.openapi.apps.createKey': 'Key erstellen',
  'pages.openapi.apps.createKeyModal': 'API Key erstellen',
  'pages.openapi.apps.keyCreateSuccess': 'Schlüssel erstellt',
  'pages.openapi.apps.keyCreateFailed': 'Schlüsselerstellung fehlgeschlagen',
  'pages.openapi.apps.noPlainKey': 'Kein Klartextschlüssel zurückgegeben',
  'pages.openapi.apps.plainKeyTitle': 'API Key sicher speichern',
  'pages.openapi.apps.plainKeyHint':
    'Klartext wird nur einmal angezeigt und kann nach dem Schließen nicht erneut eingesehen werden.',
  'pages.openapi.apps.copy': 'Kopieren',
  'pages.openapi.apps.copied': 'Kopiert',
  'pages.openapi.apps.copyFailed': 'Kopieren fehlgeschlagen; bitte manuell auswählen',
  'pages.openapi.apps.close': 'Schließen',
  'pages.openapi.apps.key.name': 'Name',
  'pages.openapi.apps.key.namePlaceholder': 'Produktiv-Hauptkey',
  'pages.openapi.apps.key.prefix': 'Präfix',
  'pages.openapi.apps.key.env': 'Umgebung',
  'pages.openapi.apps.key.status': 'Status',
  'pages.openapi.apps.key.createdAt': 'Erstellt am',
  'pages.openapi.apps.key.disable': 'Deaktivieren',
  'pages.openapi.apps.key.disableConfirm': 'Diesen Schlüssel deaktivieren?',
  'pages.openapi.apps.key.disabled': 'Deaktiviert',
  'pages.openapi.apps.key.enable': 'Aktivieren',
  'pages.openapi.apps.key.enabled': 'Aktiviert',
  'pages.openapi.apps.key.rotate': 'Rotieren',
  'pages.openapi.apps.key.rotateConfirm': 'Rotation erzeugt einen neuen Schlüssel und gibt den Klartext einmalig zurück. Fortfahren?',
  'pages.openapi.apps.key.rotated': 'Rotiert',
  'pages.openapi.apps.key.delete': 'Löschen',
  'pages.openapi.apps.key.deleteConfirm': 'Diesen Schlüssel löschen? Das kann nicht rückgängig gemacht werden.',
  'pages.openapi.apps.key.deleted': 'Gelöscht',
  'pages.openapi.logs.title': 'Nutzungsprotokolle',
  'pages.openapi.logs.listTitle': 'Aufrufdetails',
  'pages.openapi.logs.dailyTitle': 'Nutzung der letzten 14 Tage',
  'pages.openapi.logs.dailyEmpty': 'Keine täglichen Nutzungsdaten',
  'pages.openapi.logs.date': 'Datum',
  'pages.openapi.logs.count': 'Aufrufe',
  'pages.openapi.logs.createdAt': 'Zeit',
  'pages.openapi.logs.requestId': 'Request ID',
  'pages.openapi.logs.requestIdPlaceholder': 'request_id aus der API-Antwort einfügen',
  'pages.openapi.logs.detail': 'Details',
  'pages.openapi.logs.detailTitle': 'Aufrufdetails',
  'pages.openapi.logs.detailLoading': 'Wird geladen…',
  'pages.openapi.logs.requestQuery': 'Query',
  'pages.openapi.logs.requestBody': 'Anfrage',
  'pages.openapi.logs.responseBody': 'Antwort',
  'pages.openapi.logs.app': 'App',
  'pages.openapi.logs.appId': 'App-ID',
  'pages.openapi.logs.apiKey': 'API Key',
  'pages.openapi.logs.userId': 'Benutzer-ID',
  'pages.openapi.logs.apiKeyId': 'Key ID',
  'pages.openapi.logs.keyPrefix': 'Key-Präfix',
  'pages.openapi.logs.method': 'Methode',
  'pages.openapi.logs.path': 'Pfad',
  'pages.openapi.logs.statusCode': 'HTTP',
  'pages.openapi.logs.code': 'Geschäftscode',
  'pages.openapi.logs.latency': 'Latenz (ms)',
  'pages.openapi.logs.loadFailed': 'Laden fehlgeschlagen',
  'pages.openapi.planTiers.title': 'Open-Platform-Tarife',
  'pages.openapi.planTiers.level': 'Stufe',
  'pages.openapi.planTiers.levelTip':
    'Plan tier level (1–5), aligned with the user profile Level. Higher numbers mean higher tiers.',
  'pages.openapi.planTiers.name': 'Name',
  'pages.openapi.planTiers.qps': 'QPS',
  'pages.openapi.planTiers.qpsTip':
    'Max requests per second (Queries Per Second). Default rate limit for API Key calls on this tier: sustained rate equals this value; burst capacity is about QPS×2 (at least 5). Applies only to API Key calls; console/admin traffic is not counted. Individual keys may override. Exceeding the limit returns HTTP 429 (biz code 42901).',
  'pages.openapi.planTiers.dailyQuota': 'Tageskontingent',
  'pages.openapi.planTiers.dailyQuotaTip':
    'Max total API requests allowed per calendar day. Counted per user/key; only API Key calls count. Individual keys may override. Exceeding the limit returns HTTP 429 (biz code 42902).',
  'pages.openapi.planTiers.maxApps': 'Max. Apps',
  'pages.openapi.planTiers.maxAppsTip':
    'Maximum number of OpenAPI apps a developer on this tier can create.',
  'pages.openapi.planTiers.maxKeys': 'Max. Keys pro App',
  'pages.openapi.planTiers.maxKeysTip': 'Maximum number of API keys allowed under each app.',
  'pages.openapi.planTiers.allowedScopes': 'Allowed permissions (scopes)',
  'pages.openapi.planTiers.allowedScopesTip':
    'API permission scopes this tier may request or be granted. App and API Key scopes must be a subset of this selection.',
  'pages.openapi.planTiers.save': 'Speichern',
  'pages.openapi.planTiers.saved': 'Gespeichert',
  'pages.openapi.planTiers.saveFailed': 'Speichern fehlgeschlagen',
  'pages.openapi.planTiers.loadFailed': 'Tarife konnten nicht geladen werden',
  'pages.openapi.planTiers.readonly': 'Beobachter haben Nur-Lesezugriff und können Tarife nicht ändern',
  'pages.openapi.admin.usageLogsTitle': 'Open-Platform-Aufrufaudit',
  'pages.openapi.admin.usageLogsList': 'Globale Aufrufprotokolle',
  'pages.openapi.admin.disableKeyConfirm': 'Diesen API Key deaktivieren?',
  'pages.openapi.admin.disableKey': 'Key deaktivieren',
  'pages.openapi.admin.keyDisabled': 'Deaktiviert',
  'pages.openapi.admin.appsTitle': 'Open-Platform-Apps',
  'pages.openapi.admin.appsList': 'Alle Entwickler-Apps',
  'pages.openapi.admin.developers': 'Entwickler',
  'pages.openapi.admin.apps': 'Apps',
  'pages.openapi.admin.keys': 'Keys gesamt',
  'pages.openapi.admin.activeKeys': 'Aktive Keys',
  'pages.openapi.admin.todayRequests': 'Aufrufe heute',
  'pages.openapi.admin.todayErrors': 'Fehler heute',
  'pages.openapi.admin.errorCount': 'Fehler',
  'pages.openapi.admin.owner': 'Eigentümer',
  'pages.openapi.admin.keyCount': 'Keys',
  'pages.openapi.admin.keyword': 'Stichwort',
  'pages.openapi.admin.keywordPlaceholder': 'App-Name / Beschreibung / Mandantencode',
  'pages.openapi.admin.statsLoadFailed': 'Statistik konnte nicht geladen werden',
  'pages.openapi.admin.noKeys': 'Keine Keys',
  'pages.openapi.admin.appEnabled': 'App aktiviert',
  'pages.openapi.admin.appDisabled': 'App deaktiviert',
  'pages.openapi.admin.appDisableConfirm': 'Diese App deaktivieren?',
  'pages.openapi.admin.appEnableConfirm': 'Diese App aktivieren?',
  'pages.openapi.admin.keyEnableConfirm': 'Diesen Schlüssel aktivieren?',
  'pages.admin.user.openapiDeveloperEnabled': 'Open Platform',
  'pages.admin.user.openapi.on': 'Freigeschaltet',
  'pages.admin.user.openapi.off': 'Nicht freigeschaltet',
  'pages.admin.user.openapiLevel': 'Open-Platform-Stufe',
  'pages.admin.user.openapiDeveloperEnabled.label': 'Entwickler freischalten',
  'pages.admin.user.openapiLevel.label': 'Stufe',
  'pages.admin.user.openapiLevel.placeholder': '1-5',
  'pages.openapi.overview.dailyUsage': 'Heutige Nutzung',
  'pages.openapi.apps.key.enableConfirm': 'Diesen Schlüssel aktivieren?',
  'pages.admin.user.section.openapi': 'Open Platform',
};
